/* =========================================================================
   Pellington - WISHLIST (heart), 5 October 2026.
   Config and CSS: snippets/pell-wishlist.liquid (window.PellWish).
   Saved page frame: sections/pell-saved-page.liquid.
   Bag drawer line: snippets/pell-bag-send.liquid.
   Record: conversion investigation/wishlist-2026-10-05/.

   The list is product handles in localStorage (pell_wish_v1), on this phone
   only. Every read and write is wrapped: private windows and some in-app
   browsers throw on storage, and then the heart still works for the visit.

   Hearts are added to cards by this script rather than in card-product.liquid,
   so the feature stays one switch (the header-group section). A heart sits in
   the card's top-right corner in BOTH languages: the sale badge is top-left
   in English and Arabic alike (checked 5 Oct), so the corner is not mirrored.

   Tracking, on save only: GA4 add_to_wishlist, Meta AddToWishlist (new pixel
   only, trackSingle), Klaviyo "Added to Wishlist", Clarity events + the tag
   wishlist=used. Sending a list or a bag: Klaviyo identify + "Sent Saved List"
   (the trigger of the "Saved list" flow), Clarity events.
   ========================================================================= */
(function () {
  'use strict';
  var C = window.PellWish;
  if (!C || window.__pellWishJs) return;
  window.__pellWishJs = true;

  var KEY = 'pell_wish_v1';
  var T = C.t;

  /* ---------------------------------------------------------------- store */
  var mem = null;
  function read() {
    if (mem) return mem.slice();
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    mem = list.filter(function (h) { return typeof h === 'string' && h; });
    return mem.slice();
  }
  function write(list) {
    mem = list.slice();
    try { localStorage.setItem(KEY, JSON.stringify(mem)); } catch (e) {}
    paint();
  }
  function has(h) { return read().indexOf(h) > -1; }
  function add(h) { var l = read(); if (l.indexOf(h) < 0) { l.unshift(h); write(l); } }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }

  /* ---------------------------------------------------------------- icons */
  function heart(on, s, col) {
    var c = on ? (col || '#304E34') : 'none';
    var st = on ? (col || '#304E34') : 'currentColor';
    return '<svg viewBox="0 0 24 24" width="' + s + '" height="' + s + '" aria-hidden="true" focusable="false"><path d="M12 20.3 4.9 13.4C3 11.6 2.9 8.6 4.6 6.7c1.8-1.9 4.8-2 6.6-.2l.8.8.8-.8c1.8-1.8 4.8-1.7 6.6.2 1.7 1.9 1.6 4.9-.3 6.7L12 20.3z" fill="' + c + '" stroke="' + st + '" stroke-width="1.25" stroke-linejoin="round"/></svg>';
  }
  var BAG = '<svg viewBox="0 0 15 15" width="14" height="14" aria-hidden="true"><path d="m3.16,13.24c-.62,0-1.03-.48-1.12-1.12l-.56-5.82c-.08-.67.51-1.12,1.12-1.12h9.81c.62.01,1.2.47,1.12,1.13l-.56,5.82c-.09.65-.51,1.12-1.12,1.12H3.16Z" fill="none" stroke="currentColor"/><path d="m3.93,5.18c0-1.98,1.6-3.58,3.58-3.58s3.58,1.6,3.58,3.58" fill="none" stroke="currentColor"/></svg>';

  /* ------------------------------------------------------------ tracking */
  function safe(fn) { try { fn(); } catch (e) {} }
  function clarity() { var a = arguments; safe(function () { if (typeof window.clarity === 'function') window.clarity.apply(null, a); }); }
  function trackSave(d) {
    safe(function () {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_wishlist', {
          currency: 'AED', value: d.price || 0,
          items: [{ item_id: String(d.id || d.handle), item_name: d.title || d.handle, price: d.price || 0 }]
        });
      }
    });
    safe(function () {
      if (typeof window.fbq === 'function') {
        window.fbq('trackSingle', C.pixel, 'AddToWishlist', {
          content_name: d.title || d.handle, content_ids: [String(d.id || d.handle)],
          content_type: 'product', value: d.price || 0, currency: 'AED'
        });
      }
    });
    safe(function () {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Added to Wishlist', {
          ProductName: d.title || d.handle, ProductID: d.id || '', Handle: d.handle,
          URL: C.shopUrl + C.root + 'products/' + d.handle, Price: d.price || 0
        });
      }
    });
    clarity('event', 'wishlist_add');
    clarity('set', 'wishlist', 'used');
  }

  /* --------------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pw-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<b>' + heart(true, 16, '#fcfaf6') + T.saved + '</b><a href="' + C.savedUrl + '">' + T.view + ' (' + read().length + ')</a>';
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
  }

  /* -------------------------------------------------------- header heart */
  function headerHeart() {
    var n = read().length;
    var old = document.querySelectorAll('.pw-hli');
    if (!n) { for (var i = 0; i < old.length; i++) old[i].remove(); return; }
    if (old.length) {
      /* Compare first: rewriting the same text is still a DOM mutation, and the
         observer below would answer it with another pass, forever. */
      for (var j = 0; j < old.length; j++) {
        var b = old[j].querySelector('.pw-n'); if (b && b.textContent !== String(n)) b.textContent = n;
        var a = old[j].querySelector('a'); if (a) a.setAttribute('aria-label', T.hdr + ' (' + n + ')');
      }
      return;
    }
    /* Beside Search, not beside the bag: with something in the bag the bag
       shows a square count box, and phone + heart + bag pushed the phone icon
       into the logo (seen in Arabic, 5 Oct). */
    var searches = document.querySelectorAll('header .header__search, .header .header__search');
    var search = null;
    for (var k = 0; k < searches.length; k++) { if (searches[k].getBoundingClientRect().width) { search = searches[k]; break; } }
    if (!search) return;
    var anchor = search.closest('dialog-trigger') || search;
    var r = search.getBoundingClientRect();
    var svg = search.querySelector('svg');
    var s = (svg && Math.round(svg.getBoundingClientRect().width)) || 20;
    var w = document.createElement('div');
    w.className = 'pw-hli';
    w.innerHTML = '<a href="' + C.savedUrl + '" class="pw-hdr" style="width:' + Math.round(r.width) + 'px;height:' + Math.round(r.height) + 'px" aria-label="' + T.hdr + ' (' + n + ')">' + heart(false, s + 3) + '<span class="pw-n">' + n + '</span></a>';
    anchor.after(w);
  }

  /* --------------------------------------------------------------- cards */
  var SKIP = '.search-suggestions__products, .predictive-search, quick-add-modal, .quick-add-modal';
  function cardData(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href');
    var handle = href.split('/products/')[1].split(/[?#/]/)[0];
    var idEl = card.querySelector('[id^="Product-"]');
    var titleEl = card.querySelector('.card-product-content__title') || card.querySelector('.visually-hidden');
    var priceEl = card.querySelector('.price__sale .exception, .price__on-sale .exception, .price__regular span:not(.visually-hidden)');
    var price = 0;
    if (priceEl) { var m = priceEl.textContent.replace(/,/g, '').match(/\d+(\.\d+)?/); if (m) price = parseFloat(m[0]); }
    return {
      handle: decodeURIComponent(handle),
      id: idEl ? idEl.id.replace('Product-', '') : '',
      title: titleEl ? titleEl.textContent.trim() : '',
      price: price
    };
  }
  function decorate() {
    var wraps = document.querySelectorAll('.card-product .card__media-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.querySelector(':scope > .pw-heart')) continue;
      if (w.closest(SKIP)) continue;
      var card = w.closest('.card-product');
      var d = cardData(card);
      if (!d) continue;
      var on = has(d.handle);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pw-heart';
      b.setAttribute('data-pw-h', d.handle);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.unsave : T.save);
      b.innerHTML = heart(on, 17);
      w.appendChild(b);
    }
  }

  /* ----------------------------------------------------------------- PDP */
  function pdp() {
    if (!C.product) return;
    var h1 = document.querySelector('main .product-info__heading-wrapper > h1.product-info__heading');
    if (!h1) return;
    var wrap = h1.parentElement;
    if (wrap.querySelector('.pw-pdpheart')) return;
    var on = has(C.product.handle);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pw-pdpheart';
    b.setAttribute('data-pw-h', C.product.handle);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? T.unsave : T.save);
    b.innerHTML = heart(on, 24);
    wrap.appendChild(b);
  }

  /* Every heart on the page shows the list's current state. */
  function paint() {
    var list = read();
    var bs = document.querySelectorAll('[data-pw-h]');
    for (var i = 0; i < bs.length; i++) {
      var on = list.indexOf(bs[i].getAttribute('data-pw-h')) > -1;
      if ((bs[i].getAttribute('aria-pressed') === 'true') === on) continue;
      bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      bs[i].setAttribute('aria-label', on ? T.unsave : T.save);
      var big = bs[i].classList.contains('pw-pdpheart');
      bs[i].innerHTML = heart(on, big ? 24 : (bs[i].classList.contains('h') ? 20 : 17));
    }
    headerHeart();
  }

  /* One capture-phase listener for every heart: a card is one big link
     underneath, so the click must stop here. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pw-h]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-pw-h');
    if (has(h)) {
      remove(h);
      clarity('event', 'wishlist_remove');
      if (b.closest('[data-pw-saved]')) renderSaved();
      return;
    }
    add(h);
    var d;
    if (b.classList.contains('pw-pdpheart') && C.product) d = C.product;
    else d = cardData(b.closest('.card-product')) || { handle: h };
    trackSave(d);
    toast();
  }, true);

  /* ---------------------------------------------------------- Saved page */
  var savedEl = document.querySelector('[data-pw-saved]');
  var savedItems = [];
  function money(cents) { return 'AED ' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function listUrl(handles) { return C.shopUrl + C.savedUrl + '?items=' + handles.map(encodeURIComponent).join(','); }

  function renderSaved() {
    if (!savedEl) return;
    var L = savedEl.dataset;
    var hs = read();
    var listEl = savedEl.querySelector('[data-pw-list]');
    var sub = savedEl.querySelector('[data-pw-sub]');
    var empty = savedEl.querySelector('[data-pw-empty]');
    var box = savedEl.querySelector('[data-pw-sendbox]');
    if (!hs.length) {
      listEl.innerHTML = ''; sub.textContent = ''; empty.hidden = false; box.hidden = true; savedItems = [];
      return;
    }
    empty.hidden = true;
    Promise.all(hs.map(function (h) {
      return fetch(C.root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (ps) {
      /* A piece that was deleted or unpublished drops out of the list quietly. */
      var keep = [];
      savedItems = [];
      ps.forEach(function (p, i) { if (p) { keep.push(hs[i]); savedItems.push(p); } });
      if (keep.length !== hs.length) { mem = keep; try { localStorage.setItem(KEY, JSON.stringify(keep)); } catch (e) {} headerHeart(); }
      if (!savedItems.length) { renderSaved(); return; }
      var n = savedItems.length;
      sub.textContent = (n === 2 ? L.lTwo : (n + ' ' + (n === 1 ? L.lPiece : L.lPieces))) + ' · ' + L.lWhere;
      listEl.innerHTML = savedItems.map(function (p) {
        var url = C.root + 'products/' + p.handle;
        var v = p.variants && p.variants[0];
        var single = p.variants && p.variants.length === 1;
        var avail = single ? !!(v && v.available) : !!p.available;
        var priceHtml = money(p.price) + (p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '');
        var action;
        if (!avail) action = '<button class="a" type="button" disabled>' + esc(L.lSold) + '</button>';
        else if (single) action =
          '<product-form data-section-id="pw-saved"><form method="post" action="' + C.root + 'cart/add" data-type="add-to-cart-form" class="form">' +
          '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1">' +
          '<button class="a" type="submit" name="add">' + BAG + esc(L.lAdd) + '</button></form></product-form>';
        /* 16 Oct 2026: a sized piece opens the size sheet (assets/pell-size-sheet.js)
           instead of leaving for the product page. */
        else action = '<button class="a" type="button" aria-haspopup="dialog" data-pell-ss-open="' + esc(url) + '">' + BAG + esc(L.lSize) + '</button>';
        return '<div class="pw-row">' +
          '<a href="' + esc(url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(p.featured_image, 300)) + '" alt="" loading="lazy" width="84" height="84"></a>' +
          '<div><a class="t" href="' + esc(url) + '">' + esc(p.title) + '</a><p class="p">' + priceHtml + '</p>' + action + '</div>' +
          '<button class="h" type="button" data-pw-h="' + esc(p.handle) + '" aria-pressed="true" aria-label="' + esc(L.lRemove) + '">' + heart(true, 20) + '</button>' +
          '</div>';
      }).join('');
      box.hidden = false;
      var wa = savedEl.querySelector('[data-pw-wa-saved]');
      if (wa) wa.href = waHref(T.waList, savedItems.map(function (p) {
        return { title: p.title, price: money(p.price), url: C.shopUrl + C.root + 'products/' + p.handle };
      }), T.waOpen + ' ' + listUrl(keep));
    });
  }

  /* A link from the email or WhatsApp message: ?items=a,b,c joins the list. */
  if (savedEl) {
    try {
      var q = new URLSearchParams(location.search).get('items');
      if (q) {
        var l = read();
        q.split(',').reverse().forEach(function (h) { h = decodeURIComponent(h).trim(); if (h && l.indexOf(h) < 0) l.unshift(h); });
        write(l);
      }
    } catch (e) {}
    renderSaved();
  }

  function waHref(head, items, tail) {
    var lines = [head];
    items.forEach(function (it) { lines.push('• ' + it.title + ' – ' + it.price); });
    if (tail) lines.push(tail);
    return 'https://wa.me/' + C.wa + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  /* ---------------------------------------------- sending (email, WhatsApp) */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function say(form, text, err) {
    var m = form.querySelector('[data-pw-msg]');
    if (!m) return;
    m.textContent = text; m.hidden = false; m.classList.toggle('is-err', !!err);
  }
  function payload(source, form) {
    if (source === 'bag') {
      var holder = form.closest('[data-pw-bagsend]');
      var items = [];
      try { items = JSON.parse(holder.querySelector('[data-pw-bag-json]').textContent || '[]'); } catch (e) {}
      return {
        source: 'bag', language: C.ar ? 'ar' : 'en',
        list_url: holder.getAttribute('data-link'),
        item_count: items.length,
        items: items.map(function (it) {
          return { title: it.title, price: 'AED ' + it.price, url: it.url, image: it.image, product_id: it.id };
        })
      };
    }
    return {
      source: 'saved', language: C.ar ? 'ar' : 'en',
      list_url: listUrl(read()),
      item_count: savedItems.length,
      items: savedItems.map(function (p) {
        return { title: p.title, price: money(p.price), url: C.shopUrl + C.root + 'products/' + p.handle, image: img(p.featured_image, 600), product_id: p.id, handle: p.handle };
      })
    };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-pw-email-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[type=email]');
    var email = (input.value || '').trim();
    if (!validEmail(email)) { say(form, T.bad, true); input.focus(); return; }
    var k = window.klaviyo;
    if (!k || typeof k.identify !== 'function' || typeof k.track !== 'function') { say(form, T.fail, true); return; }
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    var source = form.getAttribute('data-source') || 'saved';
    var data = payload(source, form);
    Promise.resolve(k.identify({ email: email }))
      .then(function () { return k.track('Sent Saved List', data); })
      .then(function () {
        say(form, T.sent, false);
        input.value = '';
        clarity('event', source === 'bag' ? 'bag_email_sent' : 'wishlist_email_sent');
      })
      .catch(function () { say(form, T.fail, true); })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pw-bag-email], [data-pw-bag-wa], [data-pw-wa-saved]');
    if (!t) return;
    if (t.hasAttribute('data-pw-bag-email')) {
      e.preventDefault();
      var form = t.closest('[data-pw-bagsend]').querySelector('[data-pw-email-form]');
      var open = form.hidden;
      form.hidden = !open;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = form.querySelector('input'); if (i) i.focus(); clarity('event', 'bag_email_open'); }
      return;
    }
    if (t.hasAttribute('data-pw-bag-wa')) clarity('event', 'bag_whatsapp');
    if (t.hasAttribute('data-pw-wa-saved')) clarity('event', 'wishlist_whatsapp');
  }, true);

  /* ------------------------------------------------------------ start up */
  function run() { decorate(); pdp(); headerHeart(); }
  run();
  /* Cards arrive after load too: filters, "load more", the drawer and
     sections re-rendered by the theme. One observer, batched to one pass per
     frame-ish tick (setTimeout, not rAF - rAF never runs in a hidden tab;
     see assets/pell-card-swipe.js). */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  /* Another tab changed the list. */
  window.addEventListener('storage', function (e) { if (e.key === KEY) { mem = null; paint(); if (savedEl) renderSaved(); } });
})();
